var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search-portal" }, [
    _c(
      "form",
      {
        staticClass: "input-group",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.query,
              expression: "query",
              modifiers: { trim: true },
            },
          ],
          ref: "input",
          attrs: {
            type: "text",
            "aria-label": "query",
            placeholder: _vm.placeholder,
          },
          domProps: { value: _vm.query },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.query = $event.target.value.trim()
            },
            blur: function ($event) {
              return _vm.$forceUpdate()
            },
          },
        }),
        _vm._v(" "),
        _vm._m(0),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "input-group-append" }, [
      _c("button", { attrs: { type: "submit", name: "search" } }, [
        _c("span", { staticClass: "fa fa-search form-control-feedback" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }